import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoaderProps {
  fullScreen?: boolean;
  size?: number;
  message?: string;
}

export const Loader: React.FC<LoaderProps> = ({ 
  fullScreen = false, 
  size = 40, 
  message = 'Loading Studio...' 
}) => {
  const containerStyle: React.CSSProperties = fullScreen ? {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--color-bg)',
    zIndex: 9999,
  } : {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'var(--space-2xl)',
    width: '100%',
    height: '100%',
  };

  return (
    <div className="nebula-loader" style={containerStyle}>
      <style>{`
        .spinner-ring {
          animation: spin 1s linear infinite;
          color: var(--color-accent);
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .loader-text {
          margin-top: var(--space-md);
          font-size: var(--font-size-subtitle);
          font-weight: var(--font-weight-medium);
          color: var(--color-text-secondary);
          animation: pulse 2s ease-in-out infinite;
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
      <Loader2 size={size} className="spinner-ring" />
      {message && <span className="loader-text">{message}</span>}
    </div>
  );
};

export default Loader;
